import noAuthorizedInterceptor from './noAuthorized';

export default noAuthorizedInterceptor;